
import timer from "@/mixins/timer";

import lazyload from "@/directives/lazyload";
import { email, required, minLength } from "vuelidate/lib/validators";
import iphone from "@/assets/images/landing/img/iphone-pro-max.webp";
import blueSms from "@/assets/images/landing/svg/i-miss-you.svg";
import greySms from "@/assets/images/landing/svg/message-grey.svg";
import "@/plugins/vuelidate"
export default {
  props: ['isMobile'],
  data() {
    return {

      images: {
        iphone,
        blueSms,
        greySms,
      },
      formLogin: {
        name: "",
        email: "",
      },
    };
  },
  mixins: [timer],

  validations: {
    formLogin: {
      name: { required, minLength: minLength(2) },
      email: { email, required },
    },
  },


  directives: {
    lazyload,
  },

  watch: {
    '$store.state.stepsUserModule.searchName': {
      immediate: true,
      handler(newName) {
        this.formLogin.name = newName;
      }
    },
    '$store.state.stepsUserModule.searchEmail': {
      immediate: true,
      handler(newEmail) {
        this.formLogin.email = newEmail;
      }
    },
  },

  computed: {
    name: {
      get() {
        return this.$store.state.stepsUserModule.searchName;
      },
      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_NAME', value);
      }
    },
    email: {
      get() {
        return this.$store.state.stepsUserModule.searchEmail;
      },
      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_EMAIL', value);
      }
    }
  },

  methods: {
    redirectUser() {
      this.name = this.formLogin.name;
      this.email = this.formLogin.email;

      if (!this.formLogin.name || !this.formLogin.email) {
        return;
      }

      const utmParams = localStorage.utmParams;
      let url = `/auth/register?plan=1&product=FREE`;
      if (utmParams) {
        url = `${url}&${utmParams}`;
      }

      this.$router.push(`${this.$store.state.userModule.isLogged ? '/account/search-credits/' : '/auth/register?plan=1&product=FREE'}`);
    },

  },
};
